<template>
    <div class="touch-strip" @click="openMore">
        <div class="content">
            <slot></slot>
        </div>
        <i class="arrow"></i>
    </div>
</template>

<script>
export default {
    methods: {
        openMore: function() {
            this.$emit('more');
        }
    }
}
</script>

<style lang="scss">
.touch-strip {
    position: relative;
    padding: 8px 33px 8px 0;
    background: #fff;
    font-size: 14px;
    line-height: 24px;
    touch-action: manipulation;
    // .content {
    //     padding: 0 12px;
    // }
    .sub-content {
        padding: 0 12px;
        font-size: 12px;
        color: #999;
    }

    .arrow {
        position: absolute;
        right: 6px;
        top: 50%;
        width: 24px;
        height: 24px;
        transform: translate(0, -50%) scale(0.7);

        &:before,
        &:after {
            content: " ";
            position: absolute;
            left: 50%;
            top: 50%;
            width: 50%;
            height: 2px;
            margin: -1px 0 0 -25%;
            background: #c2c6cc;
        }

        &:before {
            transform: translate(0, -4px) rotate(45deg);
        }

        &:after {
            transform: translate(0, 4px) rotate(-45deg);
        }
    }
}
</style>



// WEBPACK FOOTER //
// TouchStrip.vue